import { TYPE_STRING } from './input-types';

export const id = 'itemSku';
export const apiKey = 'ItemSku';
export const type = TYPE_STRING;

export const itemSku = {
  id,
  apiKey,
  type,
};
